import { BusinessManagerService } from './BusinessManager.types'
import { BusinessManagerServiceMock } from './BusinessManager.mock'
import { BusinessManagerServiceImplementation } from './BusinessManager'

export const businessManagerService: BusinessManagerService =
  process.env.NODE_ENV !== 'test'
    ? new BusinessManagerServiceImplementation()
    : new BusinessManagerServiceMock()
